import { __awaiter } from "tslib";
import { useCallback, useRef, useState } from 'react';
import { _console } from '@shared/helpers';
const resolveModalDefinition = (entry) => {
    if (!entry) {
        return null;
    }
    if (typeof entry === 'object' && entry !== null && 'component' in entry) {
        return entry;
    }
    return { component: entry };
};
const smallGreyFont = 'color: grey; font-size: 85%';
const keyFont = 'color: orange;font-weight: bold;';
const nameFont = 'color: white;background:dodgerblue;padding: 0 2px';
export const useModal = (modals) => {
    var _a;
    const modalStack = useRef([]); // For purpose of keeping track of the modal stack, especially when there are multiple modals open
    const modalsRef = useRef(modals);
    modalsRef.current = modals;
    const [modal, setModal] = useState(null);
    const modalName = modal ? modal.name : '';
    const modalDefinition = modalName
        ? resolveModalDefinition(modalsRef.current[modalName])
        : null;
    const ModalComponent = (_a = modalDefinition === null || modalDefinition === void 0 ? void 0 : modalDefinition.component) !== null && _a !== void 0 ? _a : null;
    const openModal = useCallback((name, props = {}) => {
        var _a, _b;
        const activeModalDefinition = resolveModalDefinition(modalsRef.current[name]);
        _console.log(`%cModalOrchestrator %copening: %c${name}`, keyFont, smallGreyFont, nameFont);
        // Check if the modal is already open
        const existingModalIndex = modalStack.current.findIndex((modal) => modal.name === name);
        if (existingModalIndex !== -1) {
            const existingModal = modalStack.current[existingModalIndex];
            // If the modal is already open, replace props and create a new object to trigger a re-render
            const updatedModal = Object.assign(Object.assign({}, existingModal), { props: Object.assign(Object.assign({}, ((_a = activeModalDefinition === null || activeModalDefinition === void 0 ? void 0 : activeModalDefinition.defaultProps) !== null && _a !== void 0 ? _a : {})), props) });
            modalStack.current[existingModalIndex] = updatedModal;
            setModal(updatedModal);
            return;
        }
        if (!activeModalDefinition) {
            console.error(`Modal with name "${name}" does not exist in the provided modals.`);
            return;
        }
        const newModal = {
            name,
            props: Object.assign(Object.assign({}, ((_b = activeModalDefinition.defaultProps) !== null && _b !== void 0 ? _b : {})), props),
        };
        modalStack.current.push(newModal);
        setModal(newModal);
    }, []);
    const closeModal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const currentModal = modalStack.current[modalStack.current.length - 1];
        if ((_a = currentModal === null || currentModal === void 0 ? void 0 : currentModal.props) === null || _a === void 0 ? void 0 : _a.onBeforeClose) {
            try {
                yield currentModal.props.onBeforeClose();
            }
            catch (error) {
                console.error('onBeforeClose failed:', error);
                return; // Abort close
            }
        }
        modalStack.current.pop();
        setModal((_b = modalStack.current[modalStack.current.length - 1]) !== null && _b !== void 0 ? _b : null);
    }), []);
    return { ModalComponent, modal, openModal, closeModal };
};
